module.exports = __webpack_public_path__ + "img/circle-check.svg";